<nav class="navbar navbar-expand-lg navbar-light" *ngIf="state === states.LOGIN || state === states.LOGIN_LOADING">
  <a class="navbar-brand" href="#" aria-label="RabbitRun home">
    <img src="assets/images/brand.png" class="imgg" alt="RabbitRun">
  </a>
</nav>

<main [class.auth-shell]="state === states.LOGIN || state === states.LOGIN_LOADING"
      [class.mfa-shell]="state !== states.LOGIN && state !== states.LOGIN_LOADING">
  <section id="logreg-forms" [class.mfa-card]="state !== states.LOGIN && state !== states.LOGIN_LOADING" aria-live="polite">
    <ng-container *ngIf="state === states.LOGIN || state === states.LOGIN_LOADING">
      <h1 class="h3 mb-3 font-weight-normal sign_in">Sign in</h1>
      <form class="example-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
        <mat-form-field class="example-full-width">
          <input matInput type="email" placeholder="Email" formControlName="email"
                 autocomplete="username" [readonly]="state === states.LOGIN_LOADING">
          <mat-error *ngIf="loginForm.controls.email.hasError('required')">Email is required</mat-error>
          <mat-error *ngIf="loginForm.controls.email.hasError('email')">Email is invalid</mat-error>
        </mat-form-field>

        <mat-form-field class="example-full-width">
          <input [type]="hide ? 'password' : 'text'" matInput placeholder="Password"
                 formControlName="password" autocomplete="current-password"
                 [readonly]="state === states.LOGIN_LOADING">
          <!-- <button type="button" mat-icon-button matSuffix class="visibility-button"
                  (click)="hide = !hide" [attr.aria-label]="hide ? 'Show password' : 'Hide password'">
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button> -->
          <mat-icon class="visibility-icon" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          <mat-error *ngIf="loginForm.controls.password.hasError('required')">Password is required</mat-error>
          <mat-error *ngIf="loginForm.controls.password.hasError('minlength')">Password is invalid</mat-error>
        </mat-form-field>

        <button class="w-full" mat-raised-button color="primary" type="submit"
                [disabled]="loginForm.invalid || state === states.LOGIN_LOADING">
          {{ state === states.LOGIN_LOADING ? 'Signing in…' : 'Login' }}
        </button>

        <div class="m-t-12 text-right">
          <a [routerLink]="['/forgotpassword']" class="forgot-pwd">Forgot password?</a>
        </div>
      </form>
    </ng-container>

    <ng-container *ngIf="state !== states.LOGIN && state !== states.LOGIN_LOADING && state !== states.AUTHENTICATED">
      <div class="otp-panel">
        <div class="mfa-brand">
          <img src="assets/images/brand.png" alt="RabbitRun">
        </div>
        <h1 class="h3 mb-2 font-weight-normal sign_in">Verify your identity</h1>
        <p class="otp-help" id="otp-help">Enter the verification code sent to your email. Code expires in 59 seconds.</p>

        <form class="mfa-form" [formGroup]="otpForm" (ngSubmit)="verifyOtp()" novalidate>
          <div class="mfa-code-group">
            <label for="mfa-code" class="sr-only">Six digit verification code</label>
            <input id="mfa-code" class="mfa-code" formControlName="otp" type="text" inputmode="numeric"
                   autocomplete="one-time-code" maxlength="6" pattern="[0-9]*"
                   aria-describedby="otp-help otp-message" placeholder="6-digit code"
                   (input)="normalizeOtpInput($event)" [readonly]="state === states.OTP_VERIFYING">
          </div>

          <p id="otp-message" class="otp-message error" role="alert"
             *ngIf="state === states.OTP_INVALID">The code is invalid. Please try again.</p>
          <p id="otp-message" class="otp-message error" role="alert"
             *ngIf="state === states.OTP_EXPIRED">This code has expired. Return to sign in for a new code.</p>
          <p id="otp-message" class="otp-message error" role="alert"
             *ngIf="state === states.OTP_RATE_LIMITED">Too many attempts. Please wait before trying again.</p>
          <p id="otp-message" class="otp-message error" role="alert"
             *ngIf="state === states.SERVICE_ERROR">We could not complete verification right now. Please try again.</p>
          <p id="otp-message" class="otp-message success" role="status"
             *ngIf="state === states.OTP_RESEND_SUCCESS">A new code was sent. Only the latest code will work.</p>

          <div class="mfa-trusted-device">
            <label class="mfa-checkbox" for="mfa-remember-device">
              <input id="mfa-remember-device" type="checkbox"
                     [(ngModel)]="rememberDevice" [ngModelOptions]="{standalone: true}">
              Trust this browser after verification
            </label>
            <label for="mfa-trusted-device-days" class="sr-only">Trust this browser duration</label>
            <select id="mfa-trusted-device-days" class="mfa-trusted-device-days"
                    [(ngModel)]="trustedDeviceDays" [ngModelOptions]="{standalone: true}"
                    [disabled]="!rememberDevice">
              <option *ngFor="let days of trustedDeviceDurations" [value]="days">{{ days }} days</option>
            </select>
            <p class="trusted-device-help">Use only on a private device. Your password is still required on future sign-ins.</p>
          </div>

          <div class="otp-actions">
            <button class="mfa-action mfa-action-primary" type="submit"
                    [disabled]="otpForm.invalid || state === states.OTP_VERIFYING || state === states.OTP_EXPIRED">
              {{ state === states.OTP_VERIFYING ? 'Verifying…' : 'Verify' }}
            </button>
            <button class="mfa-action mfa-action-secondary" type="button" (click)="resendOtp()"
                    [disabled]="resendCooldownSeconds > 0 || state === states.OTP_VERIFYING || state === states.OTP_EXPIRED">
              {{ resendCooldownSeconds > 0 ? 'Resend in ' + resendCooldownSeconds + 's' : 'Resend code' }}
            </button>
            <button class="mfa-action mfa-action-neutral" type="button" (click)="returnToLogin()">Log out</button>
          </div>
        </form>
      </div>
    </ng-container>
  </section>
</main>
